import { render, staticRenderFns } from "./technicalBusinessScoreWZ.vue?vue&type=template&id=360c8562&scoped=true"
import script from "./technicalBusinessScoreWZ.vue?vue&type=script&lang=js"
export * from "./technicalBusinessScoreWZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360c8562",
  null
  
)

export default component.exports